import { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
import parseQuery from '@/mixins/parseQuery'
import { getAllActivityRule } from '@/apis/qiweiMiniGame'
export default {
  mixins: [parseQuery],
  data () {
    return {
      fields: ['activityId', 'uid', 'appkey', 'sceneType', 'type'],
    }
  },
  computed: {
    activityType () {
      return this.params.type
    },
  },
  methods: {
    getRuleInfo () {
      getAllActivityRule({
        activityId: this.activityId,
        uid: this.uid,
        appkey: this.appkey,
        sceneType: this.sceneType,
        type: this.type,
      }).then(res => {
        console.log(res)
      })
    },
    onShowRule () {
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.enterprise_wx_h5_rule_button,
        {
          ...this.trackActInfo,
          activity_status: this.activityInfo.activityStatus,
        },
        this.trackUserInfo,
      )
      this.$refs.ruleRef.triggerVisible(true)
    },
  },
}